import { render, staticRenderFns } from "./PublicExamEvaluation.vue?vue&type=template&id=0b95f51b"
import script from "./PublicExamEvaluation.vue?vue&type=script&lang=js"
export * from "./PublicExamEvaluation.vue?vue&type=script&lang=js"
import style0 from "./PublicExamEvaluation.vue?vue&type=style&index=0&id=0b95f51b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports